import {
    Box,
    Button,
    Card,
    CardContent,
    Switch,
    Tooltip,
    Typography,
} from '@mui/material';

import {
    InfoOutlined,
} from '@mui/icons-material';

import { Trans } from 'react-i18next';

import DurationPicker from '../shared/DurationPicker';
import { useContext, useEffect, useState } from 'react';
import { Context } from '../../context/context';
import api from '../../api';

function EditAccountCreditPage() {
    const [{ user },] = useContext(Context);

    const [institute, setInstitute] = useState(null);
    const [maxFlexTimeCredit, setMaxFlexTimeCredit] = useState(0)
    const [maxFlexTimeDeficit, setMaxFlexTimeDeficit] = useState(0)
    const [hasChanges, setHasChanges] = useState(false)

    useEffect(() => {
        if (user.id !== '') {
            api.readInstitute(user.institute).then(res => {
                setInstitute(res);
                setMaxFlexTimeCredit(res.maxFlexTimeCredit)
                setMaxFlexTimeDeficit(res.maxFlexTimeDeficit)
            });
        };
    }, [user]);


    useEffect(() => {
        setHasChanges(institute?.maxFlexTimeCredit !== maxFlexTimeCredit || institute?.maxFlexTimeDeficit !== maxFlexTimeDeficit)
    }, [maxFlexTimeCredit, maxFlexTimeDeficit, institute])

    const handleSwitchAllowAdditionalCompensationForClosingDays = (allow) => {
        api.updateInstitute(institute.name, {
            ...institute,
            allowAdditionalCompensationForClosingDays: allow,
        }).then(res => {
            api.readInstitute(user.institute).then(res => setInstitute(res));
        });
    };

    const handleSave = () => {
        api.updateInstitute(institute.name, {
            ...institute,
            maxFlexTimeCredit:maxFlexTimeCredit,
            maxFlexTimeDeficit: maxFlexTimeDeficit,
        }).then(res => {
            api.readInstitute(user.institute).then(res => setInstitute(res));
        });
    }

    const tooltipMsg = <Trans i18nKey="tooltipMsg" ns="instituteConfigurationPage">"Diese Einstellung wird verwendet, um die Mitarbeitenden auf hohe Zeitguthaben bzw. Zeitdefizite aufmerksam zu machen. Wenn sie in die Nähe der Grenzen geraten, erhalten sie eine Warnung auf ihrer Startseite. Eine automatische Korrektur der Arbeitszeitkonten bei Überschreitung der Grenzen findet nicht statt."</Trans>

    return (
        <>
            <Card sx={{ p: 3 }}>
                <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}>
                        <Typography variant="h5"><Trans i18nKey="grenzenFürZeitguthaben" ns="instituteConfigurationPage">Grenzen für Zeitguthaben</Trans></Typography>
                        <Tooltip title={tooltipMsg} placement="right-end">
                            <InfoOutlined sx={{ pl: 1 }} />
                        </Tooltip>
                    </Box>
                    {
                        institute &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                                <Typography sx={{ pb: 2 }}>
                                    <Trans i18nKey="grenzenFürZeitguthabenSubTitle" ns="instituteConfigurationPage">Am Monatsende dürfen die Mitarbeitenden ein Zeitguthaben innerhalb der folgenden Grenzen in den Folgemonat übertragen:</Trans>
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', pb: 2 }}>
                                    <Trans i18nKey="grenzenFürZeitguthaben" ns="instituteConfigurationPage">Zeitguthaben bis zu:</Trans>
                                    <Box>
                                        <DurationPicker id={'1'} value={maxFlexTimeCredit} onChange={({value}) => setMaxFlexTimeCredit(value) } type={'positive'} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', pb: 2 }}>
                                    <Trans i18nKey="zeitguthabenFürBrückentage" ns="instituteConfigurationPage">Zzg. Zeitguthaben für Brückentage</Trans>
                                    <Switch
                                        checked={institute?.allowAdditionalCompensationForClosingDays || false}
                                        onChange={(e) => handleSwitchAllowAdditionalCompensationForClosingDays(e.target.checked)}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography sx={{ pt: .5 }}>
                                        <Trans i18nKey="maxTimeDeficit" ns="instituteConfigurationPage">Zeitdefizit bis zu:</Trans>
                                    </Typography>
                                    <Box>
                                        <DurationPicker id={'2'} value={maxFlexTimeDeficit} onChange={({ value }) => setMaxFlexTimeDeficit(value)} type={'negative'} />
                                    </Box>
                                </Box>
                            </Box>
                            <Button variant='contained' sx={{ width: 'fit-content', ml: 'auto', mt: 3 }} onClick={handleSave} disabled={!hasChanges}>Speichern</Button>
                        </Box>
                    }
                </CardContent>
            </Card>
        </>
    );
};

export default EditAccountCreditPage
